export default __webpack_public_path__ + "static/media/40.18072161.png";